import { MessageCircle } from "lucide-react";

const WhatsAppFloat = () => (
  <a
    href="https://wa.me/595976724321?text=Hola%20Meli"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Escribinos por WhatsApp"
    data-testid="whatsapp-float-button"
    className="fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-magenta text-plum shadow-lg shadow-magenta/40 transition-[transform,background-color] duration-300 hover:scale-110 hover:bg-neoncyan hover:text-deepteal"
  >
    <MessageCircle className="h-6 w-6" />
  </a>
);

export default WhatsAppFloat;
